import React from 'react'
import { Link } from 'react-router-dom'
import { Translation } from 'react-i18next'
import i18n from '../../languages/lang.js'

const Header = props => {
  return (
    <Translation>
      {
        (t) => (
          <div id="header">
            <h1>{t('system.name')}</h1>
          </div>
        )
      }
    </Translation>
  )
}

export default Header
